import { SUPPORTED_LOCALES } from '../../locales';

/** URL lang 别名 → i18n locale（与 Language 下拉选项一致） */
const LANG_PARAM_ALIASES = {
  zh: 'sc',
  'zh-cn': 'sc',
  'zh-hans': 'sc',
  'zh-tw': 'tc',
  'zh-hant': 'tc',
  de: 'ge',
  ja: 'jp',
};

export function getLangParam() {
  return new URLSearchParams(window.location.search).get('lang');
}

export function hasLangParam() {
  const raw = getLangParam();
  return raw !== null && String(raw).trim() !== '';
}

export function resolveI18nLocaleFromLangParam(rawLang) {
  const normalized = String(rawLang || '').trim().toLowerCase();
  if (!normalized) {
    return 'en';
  }

  const aliased = LANG_PARAM_ALIASES[normalized];
  if (aliased && SUPPORTED_LOCALES.includes(aliased)) {
    return aliased;
  }

  if (SUPPORTED_LOCALES.includes(normalized)) {
    return normalized;
  }

  return 'en';
}

export function applyLangFromUrl(i18n) {
  if (!hasLangParam()) {
    return null;
  }
  const locale = resolveI18nLocaleFromLangParam(getLangParam());
  localStorage.removeItem('language');
  localStorage.setItem('language', locale);
  i18n.changeLanguage(locale);
  return locale;
}



// WEBPACK FOOTER //
// ./src/js/utils/urlLang.js